import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var sliderBehavior = function sliderBehavior() {
  Alpine.data('sliderBehavior', function () {
    var sliderColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'blue';
    return {
      $slider: false,
      $sliderControls: false,
      $subNav: false,
      slider: false,
      sliderColor: sliderColor,
      slidesContainer: false,
      slides: [],
      stepCount: 0,
      currentStep: 1,
      init: function init() {
        this.$slider = this.$el;
        this.$sliderControls = this.$slider.querySelector('.o-slider__controls');
        this.$subNav = document.querySelector('.m-sub-navigation');
        this.initSteps();
        this.initSlider();
      },
      initSteps: function initSteps() {
        this.slidesContainer = this.$slider.querySelector('.o-slider__slides');
        this.slides = this.slidesContainer.querySelectorAll('.o-slider__slide');
        this.stepCount = this.slides.length;
      },
      initSlider: function initSlider() {
        var sliderSteps = this.$slider.querySelector('.o-slider__slider');
        var carouselType = this.$slider.getAttribute('data-type');
        var autoplay = this.$slider.getAttribute('data-autoplay');
        this.currentStep = 1;
        this.slider = new Splide(sliderSteps, {
          type: carouselType,
          autoplay: autoplay,
          pauseOnHover: autoplay,
          pauseOnFocus: autoplay,
          arrows: false,
          pagination: false,
          perMove: 1,
          drag: true,
          destroy: 'completely',
          autoWidth: true,
          slideFocus: false,
          reducedMotion: {
            autoplay: false
          },
          classes: {
            pagination: "splide__pagination o-slider__pagination o-slider__pagination--".concat(this.sliderColor),
            page: "splide__pagination__page o-slider__pagination-button"
          }
        });
        this.sliderEvents();
        this.slider.mount();
        var slides = this.$slider.querySelectorAll('.o-slider__slide');
        slides.forEach(function (item) {
          if (item.getAttribute('aria-hidden') === "true") {
            var links = item.querySelectorAll('a.a-logo-item');
            links.forEach(function (link) {
              link.setAttribute('tabindex', '-1');
            });
          }
        });
      },
      sliderEvents: function sliderEvents() {
        var _this = this;

        this.slider.on('pagination:mounted', function (data) {
          data.items.forEach(function (item) {
            item.li.classList.add('splide__pagination__item', 'o-slider__pagination-item');
          });
        });
        this.slider.on('pagination:updated', function (data) {
          data.items.forEach(function (item) {
            var slide = item.Slides[0] || false;

            if (slide.isActive()) {
              item.li.classList.add('is-active');
            } else {
              item.li.classList.remove('is-active');
            }
          });
        });
        this.slider.on('moved', function (currentStep) {
          _this.currentStep = currentStep + 1;

          var slides = _this.$slider.querySelectorAll('.o-slider__slide');

          slides.forEach(function (item) {
            if (item.getAttribute('aria-hidden') === "true") {
              var links = item.querySelectorAll('a.a-logo-item');
              links.forEach(function (link) {
                link.setAttribute('tabindex', '-1');
              });
            } else {
              var _links = item.querySelectorAll('a.a-logo-item');

              _links.forEach(function (link) {
                link.removeAttribute('tabindex');
              });
            }
          });
        });
      },
      refresh: function refresh() {
        this.refreshSlider();
      },
      refreshSlider: function refreshSlider() {
        if (this.slider) {
          this.slider.destroy();
        }

        this.initSlider();
      },
      bindSlider: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce.300ms': function resizeWindowStopDebounce300ms() {
          this.refresh();
        },
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.refresh();
        }
      },
      prevStep: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.slider.go('<');
        }
      },
      nextStep: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          this.slider.go('>');
        }
      }
    };
  });
};